<template>
    <div class="Analyzepassword">
        <div class="Analyzepassword-explain">
            密码必须包含：大写字母、小写字母、数字、字符中任意三种以上组合。长度为8-20个字符。
        </div>
        <div class="Analyzepassword-import">
            <p>
                <i class="iconfont icondenglumimaicon"></i>
                <input placeholder="请输入旧密码"
                       autocomplete="off"
                       @input="input(formData[0].orig,0)"
                       v-model="formData[0].orig"
                       maxlength="30"
                       :type="!formData[0].typeBoolean?'text':'password'">
                <i :class="['iconfont', formData[0].typeBoolean?'iconzhengyanicon':'iconbiyanicon']"
                   @click="formData[0].typeBoolean=!formData[0].typeBoolean"></i>
                <label>{{formData[0].text}}</label>
            </p>
            <p>
                <i class="iconfont icondenglumimaicon"></i>
                <input placeholder="请输入新密码"
                       autocomplete="off"
                       @input="input(formData[1].nov,1)"
                       v-model="formData[1].nov"
                       maxlength="20"
                       minlength="8"
                       :type="!formData[1].typeBoolean?'text':'password'">
                <i :class="['iconfont', formData[1].typeBoolean?'iconzhengyanicon':'iconbiyanicon']"
                   @click="formData[1].typeBoolean=!formData[1].typeBoolean"></i>
                <label>{{formData[1].text}}</label>
            </p>
            <p>
                <i class="iconfont icondenglumimaicon"></i>
                <!-- paste禁止粘贴 -->
                <input placeholder="请确认新密码"
                       @input="input(formData[2].repe,2)"
                       v-model="formData[2].repe"
                       autocomplete="off"
                       maxlength="20"
                       minlength="8"
                       onpaste="return false"
                       :type="!formData[2].typeBoolean?'text':'password'">
                <i :class="['iconfont', formData[2].typeBoolean?'iconzhengyanicon':'iconbiyanicon']"
                   @click="formData[2].typeBoolean=!formData[2].typeBoolean"></i>
                <label>{{formData[2].text}}</label>
            </p>
        </div>
        <div class="Analyzepassword-button">
            <button @click="boxAccon">完成</button>
        </div>
        <p class="Analyzepassword-p"
           @click="forget">忘记密码?</p>
        <ht-dialog :dialogVisible.sync="dialogVisible"
                   style="top:1vh"
                   :title="title"
                   :affirm="affirm"
                   @boxAffirm="boxAffirm">
            <span class="dialogtitle"><i class="iconfont iconjingshiicon-"></i>请联系系统管理员，重置密码</span>
        </ht-dialog>
    </div>
</template>
<script>

import htDialog from 'base/ht-dialog'
import { loginInfo } from 'common/js/util.js'
import { encryptMsg } from 'common/js/encrypt'
import Cookie from 'common/js/cookie'
export default {
    name: 'uses',
    components: {
        htDialog
    },
    data () {
        return {
            affirm: '',
            cancel: '',
            dialogVisible: false,
            title: '',
            formData: [{
                orig: '',
                typeBoolean: true,
                text: ''
            }, {
                nov: '',
                typeBoolean: true,
                text: ''
            }, {
                repe: '',
                typeBoolean: true,
                text: ''
            }]
        }
    },
    created () {
    },
    methods: {
        boxAffirm (val, callBack) { // 确认
            console.log(val)
            callBack()
        },
        forget () {
            this.title = '提示'
            this.affirm = '知道了'
            this.dialogVisible = true
        },
        boxAccon () { // 完成
            let judge = false
            // 密码为空
            for (let name in this.formData) {
                if (!this.formData[name].orig && !this.formData[name].nov && !this.formData[name].repe) {
                    this.formData[name].text = '请输入密码'
                    judge = this.formData[name].text
                }
            }
            if (!judge) judge = !(!this.formData[0].text && !this.formData[1].text && !this.formData[2].text)
            if (!judge) {
                judge = !(this.formData[1].nov === this.formData[2].repe)
                if (judge) this.formData[2].text = '新输入密码不一致'
            }
            console.log(this.formData[1].nov.length, this.formData[1].nov.length < 8 && this.formData[1].nov.length > 20)
            if (!judge && (this.formData[1].nov.length < 8 || this.formData[1].nov.length > 20)) {
                this.formData[1].text = '长度为8-20个字符'
            }
            console.log(judge)
            if (!judge) this.toRegister() // 操作登录
        },
        toRegister () {
            var login = loginInfo()
            var param = {
                selfAccount: login.selfAccount,
                selfPassWord: encryptMsg(this.formData[0].orig),
                platType: 'SELFSYS',
                passWordEncrypt: 'YES',
                newPassWord: this.formData[2].repe
            }
            this.$api.changePassWord(param).then(res => {
                if (res.code === '40001') {
                    this.$main.message = {
                        text: '修改成功！'
                    }
                    this.$emit('close')
                    // 退出登录
                    setTimeout(() => {
                        // this.$router.push('/login')
                        this.$api.outLogin({ token: login.token }).then(r => {
                            Cookie.delCookie('userInfo')
                            sessionStorage.removeItem('commonality')
                            sessionStorage.removeItem('loginInfo')
                            this.$router.push('/login')
                        })
                    }, 1000)
                } else {
                    this.$main.message = {
                        type: 'error',
                        text: '修改失败！'
                    }
                }
            })
        },
        input (val, index) {
            if (!val) {
                this.formData[index].text = '请输入密码'
            } else {
                this.formData[index].text = ''
            }
            if (index === 2) {
                if (this.formData[1].nov !== this.formData[2].repe) {
                    this.formData[index].text = '新输入密码不一致'
                } else {
                    this.formData[index].text = ''
                }
            }
            var regNumber = /\d+/ // 验证0-9的任意数字最少出现1次。
            // var regString = /[a-zA-Z]+/ // 验证大小任意字母最少出现1次。
            var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]")
            var A = /[A-Z]+/ // A-Z  验证大
            var a = /[a-z]+/ // a-z  验证小
            if (index === 1) {
                var str = [a.test(val), A.test(val), regNumber.test(val), pattern.test(val)]
                if (val && str.filter(r => r).length < 3) {
                    this.formData[index].text = '密码强度不够，请重新输入'
                } else {
                    this.formData[index].text = ''
                }
            }
        }
        // CheckIntensity (pwd) {
        //   // 判断输入密码的类型
        //   var Wcolor = ''
        //   var Mcolor = ''
        //   var Scolor = ''
        //   var Color_Html = ''
        //   var m = 0
        //   var Modes = 0
        //   for (var i = 0; i < pwd.length; i++) {
        //     var charType = 0
        //     var t = pwd.charCodeAt(i)
        //     if (t >= 48 && t <= 57) {
        //       charType = 1
        //     } // 为0～9十个阿拉伯数字
        //     else if (t >= 65 && t <= 90) {
        //       charType = 2
        //     } // 为26个大写英文字母
        //     else if (t >= 97 && t <= 122) {
        //       charType = 4
        //     } // 为26个小写英文字母
        //     else { charType = 4 }
        //     Modes |= charType
        //   }
        //   // 计算密码模式
        //   for (i = 0; i < 4; i++) {
        //     if (Modes & 1) {
        //       m++
        //       console.log(m)
        //     }
        //     Modes >>>= 1
        //   }
        //   if (pwd.length <= 4) { m = 1 }
        //   if (pwd.length <= 0) { m = 0 }
        //   // 返回强度级别
        //   switch (m) {
        //     case 1:
        //       Wcolor = 'pwd pwd_Weak_c'
        //       Mcolor = 'pwd pwd_c'
        //       Scolor = 'pwd pwd_c pwd_c_r'
        //       Color_Html = '弱'
        //       break
        //     case 2:
        //       Wcolor = 'pwd pwd_Medium_c'
        //       Mcolor = 'pwd pwd_Medium_c'
        //       Scolor = 'pwd pwd_c pwd_c_r'
        //       Color_Html = '中'
        //       break
        //     case 3:
        //       Wcolor = 'pwd pwd_Strong_c'
        //       Mcolor = 'pwd pwd_Strong_c'
        //       Scolor = 'pwd pwd_Strong_c pwd_Strong_c_r'
        //       Color_Html = '强'
        //       break
        //     default:
        //       Wcolor = 'pwd pwd_c'
        //       Mcolor = 'pwd pwd_c pwd_f'
        //       Scolor = 'pwd pwd_c pwd_c_r'
        //       Color_Html = '无'
        //       break
        //   }
        //   console.log(Color_Html)
        // }
    }
}
</script>
<style scoped lang="stylus" rel='stylesheet/stylus'>
.Analyzepassword {
    padding: 0.24rem
    &-explain {
        padding: 0.1rem 0.24rem
        color: #0059A3
        border: 1px solid #A7D2F5
        background-color: #EBF6FF
        line-height: 1.5
        box-sizing: border-box
        font-size: 0.12rem
    }
    &-import {
        >p {
            margin-top: 0.24rem
            width: 100%
            display: flex
            align-items: center
            height: 0.4rem
            padding: 0 0.18rem
            box-sizing: border-box
            border: 1px solid #E6E6E6
            position: relative
            label {
                position: absolute
                bottom: -0.2rem
                color: #F04646
                font-size: 0.12rem
                left: 0
            }
            input {
                outline: none
                margin-left: 0.18rem
                font-size: 0.15rem
                flex: 1
            }
            input::-webkit-input-placeholder {
                color: #C8C8C8
                font-size: 0.16rem
            }
            input::-ms-clear { // 文本输入框
                display: none
            }
            input::-ms-reveal { // 密码输入框
                display: none
            }
            i {
                color: #9BA9B5
                margin-top: -0.02rem
                font-size: 0.16rem
                cursor: pointer
            }
        }
    }
    &-button {
        button {
            width: 100%
            height: 0.4rem
            margin-top: 0.48rem
            background-color: #2396F5
            color: #fff
            border: none
            font-size: 0.16rem
            cursor: pointer
        }
    }
    &-p {
        color: #909BA8
        font-size: 0.14rem
        margin-top: 0.24rem
        text-align: right
        cursor: pointer
    }
    .dialogtitle {
        padding: 0.32rem 0.24rem
        font-size: 0.16rem
        display: flex
        align-items: center
        i {
            margin-right: 0.05rem
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/main/alter-password.vue